import { createFileRoute, Link } from "@tanstack/react-router";
import { useLocale } from "@/contexts/LocaleContext";
import { SiteShell } from "@/components/SiteShell";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import bodyCareImage from "@/assets/body-care-coming-soon.jpg";

import { publicCacheHeaders } from "@/lib/public-cache-headers";

export const Route = createFileRoute("/body-care-set")({
  headers: publicCacheHeaders,
  head: () => ({
    meta: [
      { title: "Body Care Set — LECMO × NEMRO Collaboration | Lecmo" },
      {
        name: "description",
        content:
          "A luxury body care collaboration between Lecmo and Nemro. Coming soon.",
      },
      { property: "og:title", content: "Body Care Set — LECMO × NEMRO" },
      {
        property: "og:description",
        content: "A luxury body care collaboration between Lecmo and Nemro. Coming soon.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: BodyCareSetPage,
});

function BodyCareSetPage() {
  const { t, dir } = useLocale();

  return (
    <SiteShell>
      <main className="min-h-[80svh]" style={{ backgroundColor: "#e6d7c1" }}>
        <section className="mx-auto w-full max-w-[1400px] px-3 sm:px-4 lg:px-6 py-6 md:py-10">
          <Link
            to="/"
            className={cn(
              "inline-flex min-h-[36px] items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-foreground/80 transition-colors hover:text-foreground",
              dir === "rtl" && "flex-row-reverse"
            )}
          >
            <ArrowLeft className={cn("h-4 w-4", dir === "rtl" && "rotate-180")} />
            {t("common.back")}
          </Link>

          <div className="mt-10 md:mt-16 text-center max-w-3xl mx-auto">
            <p className="text-[11px] tracking-[0.28em] uppercase text-muted-foreground">
              {t("bodyCare.eyebrow")}
            </p>
            <h1 className="mt-4 font-serif text-3xl md:text-5xl lg:text-6xl leading-tight">
              {t("bodyCare.title")}
            </h1>
            <p className="mt-4 t-body-lg text-muted-foreground">
              {t("bodyCare.subtitle")}
            </p>
          </div>

          <figure className="relative mt-10 md:mt-14 w-full overflow-hidden">
            <img
              src={bodyCareImage}
              alt={t("bodyCare.alt")}
              width={1600}
              height={1200}
              className="w-full h-auto object-cover"
            />
          </figure>

          <div className="mt-10 md:mt-16 grid gap-6 md:gap-8 text-center max-w-3xl mx-auto">
            <p className="t-body leading-relaxed text-foreground/90">
              {t("bodyCare.p1")}
            </p>
            <p className="t-body leading-relaxed text-foreground/90">
              {t("bodyCare.p2")}
            </p>
            <p className="pt-4 text-[11px] tracking-[0.24em] uppercase text-muted-foreground">
              {t("bodyCare.signature")}
            </p>
          </div>
        </section>
      </main>
    </SiteShell>
  );
}
